////////////////////////////////////////////
//
// Filter Dropdown
//
////////////////////////////////////////////


$(function() {

  var buttonClass = '.js-filter-button';
  var dropdownClass = '.js-filter-dropdown';

  if ($(dropdownClass).length > 0) {

    // When dropdown is changed, change the text of the filter button
    // This whole thing could probably be replaced by Vue...

    $(dropdownClass + ' a').on('click', function(event) {

      event.preventDefault();
      var $dropdown = $(event.currentTarget).closest(dropdownClass);
      var $button = $dropdown.prevAll(buttonClass);
      var label = $(event.currentTarget).data('label');

      $button.find('.filter-dropdown__highlight').text(label);
      $dropdown.foundation('close');
    });

  }
});

